import * as React from "react";
import type { SVGProps } from "react";
const SvgPhone = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="m17.058 1.285.692.923 2.16 2.881a5 5 0 0 1-.464 6.536l-8.087 8.087a4.57 4.57 0 0 1-5.97.424 1 1 0 1 1 1.2-1.6 2.57 2.57 0 0 0 3.356-.238l8.087-8.088a3 3 0 0 0 .279-3.92l-1.47-1.96-2.875 2.875.917 1.527a3 3 0 0 1-.451 3.665l-2.035 2.034a3 3 0 0 1-3.665.452l-1.527-.917-3.69 3.69A1 1 0 0 1 2.1 16.244L6.343 12l.552-.552.67.402 2.196 1.318a1 1 0 0 0 1.222-.15l2.034-2.035a1 1 0 0 0 .15-1.222L11.85 7.565l-.402-.67.552-.552L16.243 2.1z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgPhone;
